import api from './api';

export const deliveryService = {
  // Dashboard
  getDashboardStats: () => api.get('/delivery/dashboard-stats'),

  // Profile
  getProfile: () => api.get('/delivery/profile'),
  updateProfile: (data) => api.put('/delivery/profile', data),
  updateOnlineStatus: (status) => api.put('/delivery/online-status', { is_online: status }),

  // Orders
  getOrders: (params = {}) => api.get('/delivery/orders', { params }),
  acceptOrder: (orderId) => api.post(`/delivery/orders/${orderId}/accept`),
  updateOrderStatus: (orderId, status) => api.put(`/delivery/orders/${orderId}/status`, { status }),
  reportIssue: (orderId, issueData) =>
    api.post(`/delivery/orders/${orderId}/report-issue`, issueData),

  // Earnings
  getEarnings: (params = {}) => api.get('/delivery/earnings', { params }),
  getAnalytics: (params = {}) => api.get('/delivery/analytics', { params }),

  // Notifications
  getNotifications: (params = {}) => api.get('/delivery/notifications', { params }),
  markNotificationAsRead: (notificationId) =>
    api.post(`/delivery/notifications/${notificationId}/mark-read`),

  // Reviews
  getReviews: (params = {}) => api.get('/delivery/reviews', { params }),

  // Location
  getRecentDeliveries: () => api.get('/delivery/recent-deliveries'),
  getLocations: () => api.get('/delivery/locations'),
  getDeliveryStats: () => api.get('/delivery/stats'),
  updateLocation: (locationData) => api.post('/delivery/location/update', locationData),
  getCurrentLocation: () => api.get('/delivery/location/current'),
  getLocationHistory: () => api.get('/delivery/location/history'),
  getLocationTrail: (deliveryManId, hours = 2) =>
    api.get('/delivery/location/trail', {
      params: { delivery_man_id: deliveryManId, hours },
    }),
  // Live location tracking
  getAllLiveLocations: () => api.get('/delivery/location/live-all'),

  // Chat
  sendMessageToCustomer: (orderId, messageData) =>
    api.post(`/delivery/orders/${orderId}/chat/messages`, messageData),
  getOrderChat: (orderId) => api.get(`/delivery/orders/${orderId}/chat/messages`),
};
